/* AQQA Studio V3 storefront additions: data-driven, native Shopify cart / products */
(() => {
  'use strict';
  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => [...root.querySelectorAll(s)];
  const fmt = cents => window.AQQACart?.money?.(cents) || `${(cents/100).toFixed(2)} TL`;
  const root = (window.AQQA?.root || '/').replace(/\/$/, '') + '/';
  function init() {
    $$('.aqqa-announcement').forEach(area => {
      if (area.dataset.initialized) return;
      area.dataset.initialized = 'true';
      const slides = $$('[data-ann-slide]', area);
      if (!slides.length) return;
      let current = 0;
      const show = index => {current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==current;slide.classList.toggle('is-active',i===current);});};
      $('[data-ann-prev]',area)?.addEventListener('click',()=>show(current-1));
      $('[data-ann-next]',area)?.addEventListener('click',()=>show(current+1));
      const delay = parseInt(getComputedStyle(area).getPropertyValue('--an-delay'),10)||5000;
      if (slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let ticker = setInterval(()=>show(current+1),Math.max(delay,3000));
        area.addEventListener('mouseenter',()=>clearInterval(ticker));
        area.addEventListener('mouseleave',()=>{clearInterval(ticker);ticker=setInterval(()=>show(current+1),Math.max(delay,3000));});
      }
    });
    $$('[data-notifications]').forEach(container => {
      if (container.dataset.initialized) return;
      container.dataset.initialized='true';
      const toggle=$('[data-notifications-toggle]',container), panel=$('[data-notifications-panel]',container);
      toggle?.addEventListener('click',()=>{panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden));});
      document.addEventListener('click',e=>{if(!container.contains(e.target)){panel.hidden=true;toggle?.setAttribute('aria-expanded','false');}});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'){panel.hidden=true;toggle?.setAttribute('aria-expanded','false');}});
    });
    $$('[data-aqqa-support]').forEach(box=>{
      if(box.dataset.initialized)return;
      box.dataset.initialized='true';
      const trigger=$('[data-support-open]',box),panel=$('[data-support-panel]',box);
      trigger?.addEventListener('click',()=>{panel.hidden=!panel.hidden;trigger.setAttribute('aria-expanded',String(!panel.hidden));});
      $('[data-support-close]',box)?.addEventListener('click',()=>{panel.hidden=true;trigger?.setAttribute('aria-expanded','false');trigger?.focus();});
      document.addEventListener('keydown',e=>{if(e.key==='Escape'){panel.hidden=true;trigger?.setAttribute('aria-expanded','false');}});
    });
    const colorDialog=$('[data-aqqa-color-dialog]');
    if(colorDialog && !colorDialog.dataset.initialized){
      colorDialog.dataset.initialized='true';
      $('[data-aqqa-color-close]',colorDialog)?.addEventListener('click',()=>colorDialog.close());
      colorDialog.addEventListener('click',e=>{if(e.target===colorDialog)colorDialog.close();});
    }
    $$('[data-aqqa-card]').forEach(card => {
      if(card.dataset.initialized)return;
      card.dataset.initialized='true';
      let variants = [];
      try{variants=JSON.parse($('[data-card-variants]',card)?.textContent||'[]');}catch{return;}
      const sizeIndex=Number(card.dataset.sizeIndex),colorIndex=Number(card.dataset.colorIndex);
      const sizePanel=$('[data-card-quick-panel]',card),quickButton=$('[data-card-quick-toggle]',card),sizeList=$('[data-card-sizes-list]',card);
      const error=$('[data-card-error]',card),image=$('.product-card__first',card),chosenColor=null;
      let currentColor=colorIndex>=0 ? (variants.find(v=>v.available)||variants[0])?.options[colorIndex] : null;
      const firstColor = currentColor;
      const escapeHTML=str=>String(str??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const setPrice=variant=>{
        const price=$('[data-card-price]',card), compare=$('[data-card-compare]',card), campaign=$('[data-card-campaign-price]',card);
        if(price)price.textContent=fmt(variant.price);
        if(compare){compare.hidden=!(variant.compare_at_price>variant.price);compare.textContent=compare.hidden?'':fmt(variant.compare_at_price);}
        if(campaign){const percentage=Number(card.dataset.promoPercent)||0;campaign.textContent=fmt(Math.round(variant.price*(100-percentage)/100));}
      };
      function setColor(name){
        currentColor=name;
        const variant=variants.find(v=>v.available&&(colorIndex<0||v.options[colorIndex]===name))||variants.find(v=>colorIndex<0||v.options[colorIndex]===name);
        if(!variant)return;
        const other = variants.find(v=>v.featured_image && (colorIndex<0 || v.options[colorIndex]===name));
        const visual=variant.featured_image?.src || other?.featured_image?.src;
        const warning=$('[data-card-photo-unavailable]',card);
        if(image && visual){image.src=visual;image.srcset='';image.hidden=false;if(warning)warning.hidden=true;}
        else if(image && name!==firstColor){image.hidden=true;if(warning)warning.hidden=false;}
        else if(image){image.hidden=false;if(warning)warning.hidden=true;}
        setPrice(variant);
        if (colorIndex>=0) {
          $$('a.product-card__image, a.product-card__title',card).forEach(link => {
            try { const url=new URL(card.dataset.productUrl,window.location.origin);url.searchParams.set('aqqa_color',name);link.href=url.pathname+url.search; }
            catch { /* non-storefront preview */ }
          });
        }
        if(sizePanel && !sizePanel.hidden) renderSizes();
        card.dispatchEvent(new CustomEvent('aqqa:cardcolor',{detail:{color:name}}));
      }
      async function add(variantId,button){
        if(!variantId)return;
        if(button)button.disabled=true;
        if(error)error.hidden=true;
        try{await window.AQQACart.addQuickVariant(variantId);if(sizePanel)sizePanel.hidden=true;quickButton?.setAttribute('aria-expanded','false');await window.AQQACart.showQuickCart();}
        catch(e){if(error){error.textContent=e.message||'Ürün sepete eklenemedi.';error.hidden=false;}}
        finally{if(button)button.disabled=false;}
      }
      function renderSizes(){
        if(!sizeList)return;
        sizeList.innerHTML='';
        if(sizeIndex<0){
          const button=document.createElement('button');button.type='button';button.textContent='SEPETE EKLE';
          const variant=variants.find(v=>v.available&&(colorIndex<0||v.options[colorIndex]===currentColor));
          button.disabled=!variant;button.addEventListener('click',()=>add(variant?.id,button));sizeList.append(button);return;
        }
        const sizes=[...new Set(variants.filter(v=>colorIndex<0||v.options[colorIndex]===currentColor).map(v=>v.options[sizeIndex]))];
        sizes.forEach(size=>{
          const variant=variants.find(v=>v.options[sizeIndex]===size&&(colorIndex<0||v.options[colorIndex]===currentColor));
          const button=document.createElement('button');button.type='button';button.textContent=size;
          button.disabled=!variant?.available;
          button.setAttribute('aria-label',`${escapeHTML(size)} numara${!variant?.available?' stokta yok':''}`);
          button.addEventListener('click',()=>add(variant.id,button));sizeList.append(button);
        });
      }
      quickButton?.addEventListener('click',()=>{if(!sizePanel)return;sizePanel.hidden=!sizePanel.hidden;quickButton.setAttribute('aria-expanded',String(!sizePanel.hidden));if(!sizePanel.hidden)renderSizes();});
      $('[data-card-colors-open]',card)?.addEventListener('click',()=>{
        if(!colorDialog)return;
        const body=$('[data-aqqa-color-dialog-body]',colorDialog),template=$('[data-card-colors-template]',card);
        if(!body||!template)return;
        body.innerHTML='';body.append(template.content.cloneNode(true));
        $$('[data-card-select-color]',body).forEach(button=>button.addEventListener('click',()=>{setColor(button.dataset.cardSelectColor);colorDialog.close();}));
        if(typeof colorDialog.showModal==='function')colorDialog.showModal();
      });
      // Shopify theme card respects the currently selected/available color variant.
      if(colorIndex>=0 && currentColor)setColor(currentColor);
    });
    // On mobile, footer headings may be collapsed; desktop columns remain expanded.
    const syncFooter=()=>$$('.aqqa-footer-mobile-details').forEach(el=>{if(innerWidth>749)el.open=true;});
    syncFooter();
    if(!window.__aqqaFooterResize){window.__aqqaFooterResize=true;window.addEventListener('resize',syncFooter);}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
